import { render } from "./wellness.vue?vue&type=template&id=3bb355f1&scoped=true"
import script from "./wellness.vue?vue&type=script&lang=js"
export * from "./wellness.vue?vue&type=script&lang=js"

import "./wellness.vue?vue&type=style&index=0&id=3bb355f1&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb355f1"]])

export default __exports__